<template>
  <button
    class="fixed
    bottom-0
    right-0
    m-5
    lg:m-10
    p-0
    w-16
    h-16
    bg-yellow-400
    rounded-full
    hover:bg-yellow-500
    active:shadow-lg
    mouse
    shadow
    transition
    ease-in
    duration-200
    focus:outline-none"

    @click="activeAdd"
  >
    <font-awesome-icon :icon="['fas','plus']" class="text-gray-800 rotate" :class="rotate" size="lg"/>
  </button>
</template>

<script>
export default {
  data() {
    return {
      activated: false,
      rotate: 'rotate-0'
    };
  },
  watch: {
    activated: function () {
      if(this.activated) this.rotate = 'rotate-45'
      else this.rotate = 'rotate-0'
    }
  },
  methods: {
    activeAdd() {
      this.activated = !this.activated;
    }
  }
}
</script>

<style scoped>
.rotate {
  transition: transform .5s ease-in-out;
}
.rotate-0 {
  transform: rotateZ(0deg);
}
.rotate-45 {
  transform: rotateZ(45deg);
}
</style>